import { usePage } from 'constants/pages';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import UpgradeYourPlanPage from 'pages/UpgradeYourPlanPage';
import { useUserContext } from 'common/contexts/UserContext';
import { useHasPermission } from './permissions';
import { isSubscriptionActive } from './subscription';

interface Props {
  children: React.ReactNode;
}

/**
 * Checks if the current user has the required permissions
 * to access the requested page; redirecting to the landing
 * if not.
 * @param props
 * @returns
 */
export const PermissionGate: React.FC<Props> = (props) => {
  const { children } = props;

  const { user } = useUserContext();
  const page = usePage();
  const location = useLocation();
  const hasPermission = useHasPermission(page?.requiredPermissions);
  const isActive = isSubscriptionActive(user?.company?.subscription_status);

  if ((isActive || page?.isAlwaysAccessible) && hasPermission) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return <UpgradeYourPlanPage redirectedFromPage={location.pathname} />;
};
PermissionGate.displayName = 'PermissionGate';
